import rt from "../../@babel/runtime/helpers/esm/extends.mjs";
import v from "../../@babel/runtime/helpers/esm/toConsumableArray.mjs";
import ye from "../../@babel/runtime/helpers/esm/defineProperty.mjs";
import k from "../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import h from "../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import it from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import at from "../../@babel/runtime/helpers/esm/typeof.mjs";
import Ie from "../../rc-util/es/hooks/useMergedState.mjs";
import { warningOnce as nt } from "../../rc-util/es/warning.mjs";
import * as o from "react";
import lt, { isMultiple as Ce } from "./BaseSelect.mjs";
import ot from "./hooks/useCache.mjs";
import ut from "./hooks/useFilterOptions.mjs";
import ct from "./hooks/useId.mjs";
import st from "./hooks/useOptions.mjs";
import Me from "./hooks/useRefFunc.mjs";
import dt from "./OptGroup.mjs";
import ft from "./Option.mjs";
import vt from "./OptionList.mjs";
import mt from "./SelectContext.mjs";
import { hasValue as pt, toArray as ht } from "./utils/commonUtil.mjs";
import { fillFieldNames as St, flattenOptions as gt, injectPropsWithOption as we } from "./utils/valueUtil.mjs";
import bt, { warningNullOptions as Ot } from "./utils/warningPropsUtil.mjs";
var Vt = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "value", "defaultValue", "labelInValue", "onChange"], _t = ["inputValue"];
function yt(a) {
  return !a || at(a) !== "object";
}
var xe = /* @__PURE__ */ o.forwardRef(function(a, De) {
  var Ne = a.id, u = a.mode, B = a.prefixCls, Pe = B === void 0 ? "rc-select" : B, J = a.backfill, K = a.fieldNames, Ee = a.inputValue, q = a.searchValue, R = a.onSearch, z = a.autoClearSearchValue, Q = z === void 0 ? !0 : z, U = a.onSelect, X = a.onDeselect, Y = a.dropdownMatchSelectWidth, H = Y === void 0 ? !0 : Y, L = a.filterOption, $ = a.filterSort, C = a.optionFilterProp, M = a.optionLabelProp, Z = a.options, ee = a.children, te = a.defaultActiveFirstOption, re = a.menuItemSelectedIcon, ie = a.virtual, ae = a.direction, ne = a.listHeight, le = ne === void 0 ? 200 : ne, oe = a.listItemHeight, ue = oe === void 0 ? 20 : oe, Fe = a.value, ke = a.defaultValue, ce = a.labelInValue, se = a.onChange, Re = it(a, Vt), de = ct(Ne), w = Ce(u), S = !!(!Z && ee), He = o.useMemo(function() {
    return L === void 0 && u === "combobox" ? !1 : L;
  }, [L, u]), d = o.useMemo(
    function() {
      return St(K, S);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(K),
      S
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Le = Ie("", {
    value: q !== void 0 ? q : Ee,
    postState: function(t) {
      return t || "";
    }
  }), fe = h(Le, 2), g = fe[0], x = fe[1], O = st(Z, ee, d, C, M), V = O.valueOptions, $e = O.labelOptions, A = O.options, W = o.useCallback(function(r) {
    var t = ht(r);
    return t.map(function(e) {
      var i, n, l, m, f;
      if (yt(e))
        i = e;
      else {
        var y;
        l = e.key, n = e.label, i = (y = e.value) !== null && y !== void 0 ? y : l;
      }
      var c = V.get(i);
      if (c) {
        var b;
        if (n === void 0 && (n = c == null ? void 0 : c[M || d.label]), l === void 0 && (l = (b = c == null ? void 0 : c.key) !== null && b !== void 0 ? b : i), m = c == null ? void 0 : c.disabled, f = c == null ? void 0 : c.title, process.env.NODE_ENV !== "production" && !M) {
          var I = c == null ? void 0 : c[d.label];
          I !== void 0 && !/* @__PURE__ */ o.isValidElement(I) && !/* @__PURE__ */ o.isValidElement(n) && I !== n && nt(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: n,
        value: i,
        key: l,
        disabled: m,
        title: f
      };
    });
  }, [d, M, V]), We = Ie(ke, {
    value: Fe
  }), ve = h(We, 2), me = ve[0], je = ve[1], Te = o.useMemo(function() {
    var r, t = W(me);
    return u === "combobox" && !((r = t[0]) !== null && r !== void 0 && r.value) ? [] : t;
  }, [me, W, u]), Ge = ot(Te, V), pe = h(Ge, 2), s = pe[0], he = pe[1], Be = o.useMemo(function() {
    if (!u && s.length === 1) {
      var r = s[0];
      if (r.value === null && (r.label === null || r.label === void 0))
        return [];
    }
    return s.map(function(t) {
      var e;
      return k(k({}, t), {}, {
        label: (e = t.label) !== null && e !== void 0 ? e : t.value
      });
    });
  }, [u, s]), D = o.useMemo(function() {
    return new Set(s.map(function(r) {
      return r.value;
    }));
  }, [s]);
  o.useEffect(function() {
    if (u === "combobox") {
      var r, t = (r = s[0]) === null || r === void 0 ? void 0 : r.value;
      x(pt(t) ? String(t) : "");
    }
  }, [s]);
  var N = Me(function(r, t) {
    var e, i = t ?? r;
    return e = {}, ye(e, d.value, r), ye(e, d.label, i), e;
  }), Je = o.useMemo(function() {
    if (u !== "tags")
      return A;
    var r = v(A), t = function(i) {
      return V.has(i);
    };
    return v(s).sort(function(e, i) {
      return e.value < i.value ? -1 : 1;
    }).forEach(function(e) {
      var i = e.value;
      t(i) || r.push(N(i, e.label));
    }), r;
  }, [N, A, V, s, u]), P = ut(Je, d, g, He, C), j = o.useMemo(function() {
    return u !== "tags" || !g || P.some(function(r) {
      return r[C || "value"] === g;
    }) ? P : [N(g)].concat(v(P));
  }, [N, C, u, P, g]), Se = o.useMemo(function() {
    return $ ? v(j).sort(function(r, t) {
      return $(r, t);
    }) : j;
  }, [j, $]), T = o.useMemo(function() {
    return gt(Se, {
      fieldNames: d,
      childrenAsData: S
    });
  }, [Se, d, S]), _ = function(t) {
    var e = W(t);
    if (je(e), se && // Trigger event only when value changed
    (e.length !== s.length || e.some(function(l, m) {
      var f;
      return ((f = s[m]) === null || f === void 0 ? void 0 : f.value) !== (l == null ? void 0 : l.value);
    }))) {
      var i = ce ? e : e.map(function(l) {
        return l.value;
      }), n = e.map(function(l) {
        return we(he(l.value));
      });
      se(
        // Value
        w ? i : i[0],
        // Option
        w ? n : n[0]
      );
    }
  }, Ke = o.useState(null), ge = h(Ke, 2), qe = ge[0], E = ge[1], ze = o.useState(0), be = h(ze, 2), Qe = be[0], Ue = be[1], Oe = te !== void 0 ? te : u !== "combobox", Ve = o.useCallback(function(r, t) {
    var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = e.source, n = i === void 0 ? "keyboard" : i;
    Ue(t), J && u === "combobox" && r !== null && n === "keyboard" && E(String(r));
  }, [J, u]), F = function(t, e, i) {
    var n = function() {
      var G, p = he(t);
      return [ce ? {
        label: p == null ? void 0 : p[d.label],
        value: t,
        key: (G = p == null ? void 0 : p.key) !== null && G !== void 0 ? G : t
      } : t, we(p)];
    };
    if (e && U) {
      var l = n(), m = h(l, 2), f = m[0], y = m[1];
      U(f, y);
    } else if (!e && X && i !== "clear") {
      var c = n(), b = h(c, 2), I = b[0], tt = b[1];
      X(I, tt);
    }
  }, _e = Me(function(r, t) {
    var e, i = w ? t.selected : !0;
    i ? e = w ? [].concat(v(s), [r]) : [r] : e = s.filter(function(n) {
      return n.value !== r;
    }), _(e), F(r, i), u === "combobox" ? E("") : (!Ce || Q) && (x(""), E(""));
  }), Xe = function(t, e) {
    _(t);
    var i = e.type, n = e.values;
    (i === "remove" || i === "clear") && n.forEach(function(l) {
      F(l.value, !1, i);
    });
  }, Ye = function(t, e) {
    if (x(t), E(null), e.source === "submit") {
      var i = (t || "").trim();
      if (i) {
        var n = Array.from(new Set([].concat(v(D), [i])));
        _(n), F(i, !0), x("");
      }
      return;
    }
    e.source !== "blur" && (u === "combobox" && _(t), R == null || R(t));
  }, Ze = function(t) {
    var e = t;
    u !== "tags" && (e = t.map(function(n) {
      var l = $e.get(n);
      return l == null ? void 0 : l.value;
    }).filter(function(n) {
      return n !== void 0;
    }));
    var i = Array.from(new Set([].concat(v(D), v(e))));
    _(i), i.forEach(function(n) {
      F(n, !0);
    });
  }, et = o.useMemo(function() {
    var r = ie !== !1 && H !== !1;
    return k(k({}, O), {}, {
      flattenOptions: T,
      onActiveValue: Ve,
      defaultActiveFirstOption: Oe,
      onSelect: _e,
      menuItemSelectedIcon: re,
      rawValues: D,
      fieldNames: d,
      virtual: r,
      direction: ae,
      listHeight: le,
      listItemHeight: ue,
      childrenAsData: S
    });
  }, [O, T, Ve, Oe, _e, re, D, d, ie, H, le, ue, S]);
  return process.env.NODE_ENV !== "production" && (bt(a), Ot(A, d)), /* @__PURE__ */ o.createElement(mt.Provider, {
    value: et
  }, /* @__PURE__ */ o.createElement(lt, rt({}, Re, {
    // >>> MISC
    id: de,
    prefixCls: Pe,
    ref: De,
    omitDomProps: _t,
    mode: u,
    displayValues: Be,
    onDisplayValuesChange: Xe,
    direction: ae,
    searchValue: g,
    onSearch: Ye,
    autoClearSearchValue: Q,
    onSearchSplit: Ze,
    dropdownMatchSelectWidth: H,
    OptionList: vt,
    emptyOptions: !T.length,
    activeValue: qe,
    activeDescendantId: "".concat(de, "_list_").concat(Qe)
  })));
});
process.env.NODE_ENV !== "production" && (xe.displayName = "Select");
var Ae = xe;
Ae.Option = ft;
Ae.OptGroup = dt;
export {
  Ae as default
};
//# sourceMappingURL=Select.mjs.map
